var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3412",
    "data-name": "Rectangle 3412",
    width: 24,
    height: 24,
    transform: "translate(1607 21)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4679",
    "data-name": "Mask Group 4679",
    transform: "translate(-1607 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(395 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(1216.4 19.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M7.593,10.524a6.73,6.73,0,0,1-3.285-.955,13.542,13.542,0,0,1-4.183-3.9.584.584,0,0,1-.01-.708A13.671,13.671,0,0,1,4.326.951,6.333,6.333,0,0,1,7.937.01a6.6,6.6,0,0,1,2.824.876,11.722,11.722,0,0,1,3.032,2.475c.435.485.831,1.005,1.233,1.519a.609.609,0,0,1,0,.85A14.207,14.207,0,0,1,11.51,9.189a7.429,7.429,0,0,1-3.1,1.261c-.27.038-.544.05-.817.073m6.128-5.2c-.037-.052-.056-.084-.08-.111-.534-.594-1.047-1.21-1.61-1.775A8.39,8.39,0,0,0,9.744,1.8a4.662,4.662,0,0,0-2.738-.491,5.752,5.752,0,0,0-2.195.836A11.553,11.553,0,0,0,2.045,4.589c-.2.231-.378.473-.562.705A12.624,12.624,0,0,0,4.951,8.421a5.754,5.754,0,0,0,2.208.752,4.962,4.962,0,0,0,2.8-.593A10.506,10.506,0,0,0,12.9,6.272c.285-.308.551-.634.824-.95",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M110.932,52.208a3.187,3.187,0,1,1-3.174-3.191,3.182,3.182,0,0,1,3.174,3.191m-3.189,1.918a1.923,1.923,0,1,0-1.92-1.922,1.933,1.933,0,0,0,1.92,1.922",
    transform: "translate(-100.146 -46.949)",
    fill: "#0a64f9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.bd4b115e2cb5c51357e55b694a41f56d.svg";
export { ForwardRef as ReactComponent };